import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { sesionQueryOptions } from '../features/auth/api/useSesion';

/**
 * Layout sin ruta (documento 02b, §6): todo lo que cuelgue de él exige sesión. `beforeLoad`
 * comprueba la sesión contra el servidor (`GET /me`, vía `ensureQueryData` — cachea entre
 * rutas hermanas, no repite la petición si ya se resolvió) antes de dejar pasar a cualquier
 * ruta hija.
 *
 * `ensureQueryData` rechaza tanto si el servidor confirma que no hay sesión (`ERR-006`, sin
 * reintentos) como si no se pudo comprobar (fallo de red, tras los reintentos de
 * `sesionQueryOptions`): en los dos casos se manda a `/login`, nunca se deja pasar. "Ante la
 * duda, no se entra" (criterio CA-02b.7) también aplica aquí, no solo en la comprobación de rol
 * de `_autenticado/admin.tsx`.
 *
 * El destino se conserva en `?redirect=` (con la URL completa, `location.href`: pathname +
 * query + hash) para que `/login` pueda volver aquí tras el acceso.
 */
export const Route = createFileRoute('/_autenticado')({
	beforeLoad: async ({ context, location }) => {
		try {
			await context.queryClient.ensureQueryData(sesionQueryOptions);
		} catch {
			throw redirect({ search: { redirect: location.href }, to: '/login' });
		}
	},
	component: () => <Outlet />,
});
